import React, { useMemo } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useTheme } from "@mui/material/styles";
import "./style.css";

const AllDropdown = ({
  isOpen,
  toggle,
  menuItems,
  buttonStyles = {},
  menuStyles = {},
  toggleClassName = "",
  menuClassName = "",
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const visibleItems = useMemo(
    () =>
      Array.isArray(menuItems)
        ? menuItems.filter((item) => item?.show !== false)
        : [],
    [menuItems]
  );

  return (
    <Dropdown isOpen={isOpen} toggle={toggle} style={{ zIndex: 10 }}>
      <DropdownToggle
        className={`text-capitalize moreactionQuoteDetail ${toggleClassName} ${
          isDark ? "" : "text-blue-color"
        }`}
        style={{
          background: isDark ? "#2d3b4e" : "#EEEEEF",
          border: isDark ? "1px solid #3d4f66" : "none",
          color: isDark ? "#e8eaed" : undefined,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "6px 16px",
          borderRadius: "6px",
          fontWeight: 500,
          transition: "all 0.2s ease",
          boxShadow: isOpen
            ? isDark
              ? "0 2px 8px rgba(0,0,0,0.35)"
              : "0 2px 5px rgba(0,0,0,0.1)"
            : "none",
          ...buttonStyles,
          height: "40px",
        }}
      >
        <MoreHorizIcon
          style={{
            fontSize: "20px",
            color: isDark ? "#e8eaed" : undefined,
          }}
        />
      </DropdownToggle>
      <DropdownMenu
        className={`all-dropdown-menu-compact border-blue-color ${menuClassName}`}
        style={{
          borderRadius: "12px",
          marginTop: "6px",
          border: "1px solid rgba(6, 49, 100, 0.18)",
          padding: "4px 0",
          minWidth: 0,
          width: "max-content",
          maxWidth: "min(calc(100vw - 24px), 380px)",
          boxShadow: "var(--shadow-md)",
          ...menuStyles,
        }}
      >
        {visibleItems.length > 0 &&
          visibleItems.map((item, index) => (
            <DropdownItem
              key={index}
              className="all-dropdown-item text-blue-color"
              onClick={item?.disabled ? undefined : item?.onClick}
              disabled={item?.disabled}
              style={{
                padding: "7px 12px",
                fontSize: "0.9375rem",
                fontWeight: 500,
                lineHeight: 1.35,
                cursor: item?.disabled ? "not-allowed" : "pointer",
                transition: "background-color 0.15s ease",
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                alignItems: "center",
                gap: "10px",
                width: "100%",
                minHeight: "auto",
                textAlign: "left",
                whiteSpace: "nowrap",
                opacity: item?.disabled ? 0.5 : 1,
                borderBottom:
                  index !== visibleItems.length - 1
                    ? "1px solid #E5E7EB"
                    : "none",
              }}
            >
              {item?.icon && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {item?.icon}
                </span>
              )}
              {item?.label ?? ""}
            </DropdownItem>
          ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default AllDropdown;
